/*globals $ */

import Carousel from './Carousel';

class SlickSlider {
  constructor(app) {
    this.app = app;

    this.carousels = [];
    this.prevViewMode = '';

    $('.slick-slider').not('.slick-slider--delay').each((i, e) => {
      let _carousel   = $(e);
      let _options      = {};

      if(_carousel.attr('data-slick') == 'simple') {
        let _options_base = {
          autoplay          : false,
          arrows            : true,
          slidesToShow      : 1,
          slidesToScroll    : 1,
          dots              : true,
          infinite          : true,
          pauseOnHover      : false
        };

        _options = {
          'pc'      : _options_base,
          'tablet'  : _options_base,
          'sp'      : _options_base
        };
      } else if(_carousel.attr('data-slick') == 'products') {
        let _options_base = {
          autoplay          : false,
          arrows            : true,
          slidesToShow      : 3,
          slidesToScroll    : 3,
          dots              : true,
          infinite          : true,
          pauseOnHover      : false,
          speed             : 200,
          prevArrow: '<button type="button" class="slick-arrow slick-prev"></button>',
          nextArrow: '<button type="button" class="slick-arrow slick-next"></button>'
        };

        _options = {
          'pc'      : _options_base,
          'tablet'  : _options_base,
          'sp'      : _options_base
        };
      }

      // _carousel.slick(_options);
      // this.carousels.push(_carousel);

      this.carousels.push(new Carousel(_carousel, _options));
    });

    $(window).on('resize', () => {
      this.onWindowResize();
    });
    this.onWindowResize();
  }

  init() {

  }

  onWindowResize() {

    if(this.prevViewMode != this.app.viewMode) {

      if(this.carousels.length > 0) {
        for(let i = 0; i < this.carousels.length; i++) {
          // this.carousels[i].slick('unslick');
          // this.carousels[i].addClass('slick-slider');
          if(this.carousels[i].$target.hasClass('slick-initialized')) {
            this.carousels[i].$target.slick('unslick');
            this.carousels[i].$target.addClass('slick-slider');
          }

          this.carousels[i].init(this.app.viewMode);
        }
        // this.carousels = [];
        // this.carousels[i].init();
        // this.init();
      } else {
        // this.init();
        // this.carousels[i].init();
        for(let i = 0; i < this.carousels.length; i++) {
          this.carousels[i].init(this.app.viewMode);
        }
      }

      this.prevViewMode = this.app.viewMode;
    }
    /*
    $('.slick-slider[data-slick="recommend"]').each((i, e) => {
      let _gridWidth = $(e).find('.slick-slide').width() - 20;
      $(e).find('button').css('top', Math.floor(_gridWidth / 1.53 / 2));
    });
    */
  }
}

export default SlickSlider;
